import React, { useContext } from 'react'
import { SideberContext } from '../context/SidebarContext'
import { ApiContext } from '../context/ApiContext';

function Notification() {
  const { myNotification, setMyNotification, ourService, setOurService } = useContext(SideberContext)
  const { data } = useContext(ApiContext)
  return (
    <>
      {data ? <div className={myNotification ? 'Notification-main-active' : "Notification-main-unactive"} onClick={() => setMyNotification(false)}>
        <div className={myNotification ? 'Notification-main-inner-active' : "Notification-main-inner-unactive"} onClick={(e) => e.stopPropagation()}>
          {ourService ? <p className='Notification-para Notification-our-service'>{data.our_service}</p> : <p className='Notification-para Notification-our-service'>{data.about_us}</p>}
        </div>
      </div> : <div>finding</div>}
    </>
  )
}

export default Notification